import React from 'react';
import { Stack } from '@mui/material';
import { ReportParameters } from '../../components/Settings/ReportParameters';
import ReportFieldsVisibility from '../../components/Settings/ReportFieldsVisibility';
import { ReportAgeGroupSelector } from '../../components/Settings/ReportAgeGroupSelector';
import { ReportCustomField } from '../../hooks/useReportCustomFields';

interface ReportSettingsTabProps {
  display: 'flex' | 'none';
  formDisabled: boolean;
  activityFields: ReportCustomField[];
  individualFields: ReportCustomField[];
  unknownGroupFields: ReportCustomField[];
  realityFields: ReportCustomField[];
}

export const ReportSettingsTab: React.FC<ReportSettingsTabProps> = ({
  display,
  formDisabled,
  activityFields,
  individualFields,
  unknownGroupFields,
  realityFields,
}) => (
  <Stack display={display} spacing={2}>
    <ReportParameters disabled={formDisabled} />
    <ReportFieldsVisibility
      activityFields={activityFields}
      individualFields={individualFields}
      unknownGroupFields={unknownGroupFields}
      realityFields={realityFields}
      disabled={formDisabled}
    />
    <ReportAgeGroupSelector disabled={formDisabled} />
  </Stack>
);
